import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { getHostProperty } from './hooks/host';
import { MsTeams } from './lib/MsTeams';
import { telemetry } from './telemetry/Telemetry';

telemetry.init();

const container = document.getElementById('root');
const root = createRoot(container!);

// The onboarding app must never render inside MS Teams — login flows don't work in the
// Teams webview. Rendering is gated on the check, which resolves instantly for top-level
// visitors (no SDK is loaded unless we're in an iframe).
MsTeams.init().then(inTeams => {
    if (inTeams) {
        const baseUrl = getHostProperty<string>('baseUrl') ?? '';
        window.location.replace(`${baseUrl}/ms-teams/app`);
        return;
    }
    root.render(<App />);
});
